import { render, staticRenderFns } from "./ModuleDetail.vue?vue&type=template&id=0fd95c1d"
import script from "./ModuleDetail.vue?vue&type=script&lang=js"
export * from "./ModuleDetail.vue?vue&type=script&lang=js"
import style0 from "./ModuleDetail.vue?vue&type=style&index=0&id=0fd95c1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports